import React, {
    Component
} from 'react';
import Global from '../../Global';

import Slider, {
    Range
} from 'rc-slider';

import NumberFormat from 'react-number-format';

import './PhoneCompare.css'; // Tell Webpack that Button.js uses these styles

import IconCompare from '../../svgs/icon_compare.svg';
import IconMore from '../../svgs/icon_more.svg';
import IconClose from '../../svgs/icon_close.svg';
import IconClose2 from '../../svgs/icon_close2.svg';
import IconAdd from '../../svgs/icon_add.svg';
import IconTop from '../../svgs/icon_top.svg';

class PhoneCompare extends Component {

    constructor(props) {
        super(props);
        this.state = {
            brands: [],
            networkGenerations: [],
            phones: [],
            filterPhones: [],
            general: {},
            selectFilter: '',
            comparePhones: [],
            compareStatus: 'hiding',
            expandPage: 1,
            showedMobile: 4,
            tempFilter: {
                brands: [],
                networkGenerations: [],
                priceRange: [0, 10000]
            },
            filter: null,
            filters: []
        }
    }

    componentDidMount() {
        var url = Global.getAPI('phone-comparison');
        fetch(url)
            .then(response => {
                if (response.status >= 400) {
                    throw new Error("Error API: phone-comparison");
                }
                return response.json();
            })
            .then(data => {
                var filters = [];
                // add a "All" filter.
                let _allFilter = {
                    brands: [],
                    networkGenerations: [],
                    label: data.general.labelAllBrands
                };

                data.brands.map(brand => {
                    var brands = [];
                    brands.push(brand.id);
                    _allFilter.brands.push(brand.id);
                    filters.push({
                        brands: brands,
                        label: brand.label
                    })
                    return null;
                });

                filters.unshift(_allFilter);

                this.setState({
                    filters: filters,
                    brands: data.brands,
                    networkGenerations: data.networkGenerations,
                    general: data.general,
                    phones: data.phones,
                    specs: data.specs,
                    selectFilter: filters[0].label
                }, () => {
                    this.switchFilter(filters[0], false);
                });
            })
    }


    getFiltersList() {
        let html = this.state.filters.map((filter, filterIndex) =>
            <li key={"filter_" + filterIndex}
                className={(this.state.selectFilter === filter.label ? 'selected ' : '') + (filter.hidden ? 'hiding ' : '')}
                onClick={this.switchFilter.bind(this, filter, false)}
                ref={(li) => {
                    if (this.state.selectFilter === filter.label) {
                        this.selectedBrandDom = li;
                    }
                }}
            >{filter.label}</li>
        )
        return html;
    }


    getPhonesList() {
        let html = this.state.filterPhones.map((phone, phoneIndex) =>

            [<li className="" key={'phone_' + phoneIndex}>
                <div className="inner">
                    <a className="img" href={phone.url}>
                        <div className="image" style={{"backgroundImage": "url(" + encodeURI(phone.image) + ")"}}></div>
                    </a>
                    <a className="title" href={phone.url}><span>{phone.model}</span></a>
                    <div className="compareWrap" onClick={this.add2Compare.bind(this, phone)}>
                        <img alt="" src={IconCompare}/>
                    </div>
                </div>
            </li>, ' ']
        )
        return html;
    }


    showMoreResult() {
        let compareContainer = this.compareContainer;
        let child = compareContainer.querySelector('li');
        let childStyle = window.getComputedStyle(child);
        let childHeight = child.offsetHeight + parseFloat(childStyle.marginBottom);

        let page = this.state.expandPage;
        let pages = Math.ceil(this.state.filterPhones.length / 10);
        let lastRow = 2;
        let showExpand = true;

        if (page < pages) {
            page++;
            if (page === pages) {
                showExpand = false;
                if (this.state.filterPhones.length % 10 > 5) {
                    lastRow = 2;
                } else {
                    lastRow = 1;
                }
            }

            this.setState({
                opening: true,
                containerStyle: {
                    "height": childHeight * (page - 1) * 2 + 'px'
                },
                expandPage: page,
                showExpand: showExpand
            }, () => {

                setTimeout(() => {
                    this.setState({
                        containerStyle: {
                            "height": childHeight * (page - 1) * 2 + lastRow * childHeight + 'px'
                        }
                    });
                }, 30);

            })
        }

    }


    showMoreMobileResult() {
        let compareContainer = this.compareContainer;
        let child = compareContainer.querySelector('li');
        let childStyle = window.getComputedStyle(child);
        let childHeight = child.offsetHeight + parseFloat(childStyle.marginBottom);

        let page = this.state.expandPage;
        let pages = Math.ceil(this.state.filterPhones.length / 4);
        let lastRow = 2;
        let showMobileExpand = true;

        if (page < pages) {
            page++;
            if (page === pages) {
                showMobileExpand = false;
                if ((this.state.filterPhones.length - 1) % 4 >= 2) {
                    lastRow = 2;
                } else {
                    lastRow = 1;
                }
            }

            let showedMobile;

            if (page < pages) {
                showedMobile = 4 * page;
            } else {
                showedMobile = this.state.filterPhones.length;
            }

            this.setState({
                opening: true,
                containerStyle: {
                    "height": childHeight * (page - 1) * 2 - 10 + 'px'
                },
                expandPage: page,
                showedMobile: showedMobile,
                showMobileExpand: showMobileExpand
            }, () => {

                setTimeout(() => {
                    this.setState({
                        containerStyle: {
                            "height": childHeight * (page - 1) * 2 + lastRow * childHeight - 10 + 'px'
                        }
                    });
                }, 30);

            })
        }

    }

    add2Compare(phone) {
        var comparePhones = this.state.comparePhones || [];
        if (!comparePhones[0] && !comparePhones[1]) {
            comparePhones[0] = phone;
            this.setState({
                comparePhones: comparePhones,
                compareStatus: 'showing',
                labelPhoneComparison: this.state.general.labelPhoneComparison1
            });
        } else if (comparePhones[0] && !comparePhones[1] && comparePhones[0].model !== phone.model) {
            comparePhones[1] = phone;
            this.setState({
                comparePhones: comparePhones,
                compareStatus: 'open',
                labelPhoneComparison: this.state.general.labelPhoneComparison2
            });
        } else if (!comparePhones[0] && comparePhones[1] && comparePhones[1].model !== phone.model) {
            comparePhones[0] = phone;
            this.setState({
                comparePhones: comparePhones,
                compareStatus: 'open',
                labelPhoneComparison: this.state.general.labelPhoneComparison2
            });
        } else if (comparePhones[0] && comparePhones[1]) {
            this.setState({
                compareStatus: 'open'
            });
        }

    }

    switchCompare() {
        let compareStatus = this.state.compareStatus === 'showing' ? 'open' : 'showing';
        this.setState({
            compareStatus: compareStatus,
            showSpecs: false
        }, () => {
            this.updateCompareState();
        });
    }

    cleanCompare() {
        this.setState({
            comparePhones: [],
            showSpecs: false
        }, this.updateCompareState);
    }

    updateCompareState() {
        document.body.className = document.body.className.replace('hide-scroll', '');
        if (!this.state.comparePhones[0] && !this.state.comparePhones[1]) {
            this.setState({
                compareStatus: 'hiding',
                compareStyle: {}
            });
        } else if (this.state.comparePhones[0] && this.state.comparePhones[1]) {
            this.setState({
                labelPhoneComparison: this.state.general.labelPhoneComparison2
            });
        } else if (this.state.comparePhones[0] || this.state.comparePhones[1]) {
            this.setState({
                labelPhoneComparison: this.state.general.labelPhoneComparison1
            });
        }
    }

    removeFormCampare(phoneIndex) {
        var comparePhones = this.state.comparePhones;
        comparePhones[phoneIndex] = null;
        this.setState({
            comparePhones: comparePhones
        }, this.updateCompareState);
    }

    getCamparePhonesList() {

        let html = [0, 1].map((phoneIndex) => {
            var phone = this.state.comparePhones[phoneIndex];
            return phone ?
                [<li className="" key={'phone_' + phoneIndex}>
                    <div className="phoneWrap">
                        <div className="inner">
                            <a className="img" href={phone.url}>
                                <div className="image"
                                     style={{"backgroundImage": "url(" + encodeURI(phone.image) + ")"}}></div>
                            </a>
                            <a className="productName" href={phone.url}><span>{phone.model}</span></a>
                            <div className="closeBtn" onClick={this.removeFormCampare.bind(this, phoneIndex)}>
                                <img alt="" src={IconClose}/>
                            </div>
                        </div>

                    </div>
                    <div className={this.state.showSpecs ? "specs showing" : "specs"}>
                        <div className="spec">
                            <div className="name">{this.state.specs.capacity}</div>
                            <div className="value">
                                {
                                    Object.keys(phone.specs.capacity).map((p, pIndex) =>
                                        [<em key={"capacity_" + pIndex}>{phone.specs.capacity[p]}</em>,
                                            <i key={"capacityCutline_" + pIndex}>|</i>]
                                    )
                                }
                            </div>
                        </div>
                        <div className="spec">
                            <div className="name">{this.state.specs.screen}</div>
                            <div className="value">{phone.specs.screen}</div>
                        </div>
                        <div className="spec">
                            <div className="name">{this.state.specs.cpu}</div>
                            <div className="value">{phone.specs.cpu}</div>
                        </div>
                        <div className="spec">
                            <div className="name">{this.state.specs.ram}</div>
                            <div className="value">{phone.specs.ram}</div>
                        </div>
                        <div className="spec">
                            <div className="name">{this.state.specs.camera}</div>
                            <div className="value">{phone.specs.camera}</div>
                        </div>
                        <div className="spec">
                            <div className="name">{this.state.specs.frontCamera}</div>
                            <div className="value">{phone.specs.frontCamera}</div>
                        </div>
                        <div className="spec">
                            <div className="name">{this.state.specs.battery}</div>
                            <div className="value">{phone.specs.battery}</div>
                        </div>

                    </div>
                </li>, ' '] : [<li className="" key={'phone_' + phoneIndex}>
                    <div className="phonePlaceholder" onClick={this.switchCompare.bind(this)}>
                        <div className="inner">
                            <div className="img">
                                <img alt="" src={IconAdd}/>
                            </div>
                            <p>{this.state.general.labelSelectAnotherPhone}</p>
                        </div>
                    </div>
                </li>, ' ']
        })
        return html;
    }

    getCampareBtns() {
        var html;

        if (this.state.compareStatus === 'open' && this.state.comparePhones[0] && this.state.comparePhones[1]) {
            html = [<div className="cleanBtn2 visible-xs-inline-block text-uppercase"
                         onClick={this.cleanCompare.bind(this)} key="clean">{this.state.general.labelClearAll}</div>,
                <div className="compareBtn" onClick={this.startCompare.bind(this)}
                     key="compare">{this.state.general.labelStartCompare}</div>]
        } else if (this.state.compareStatus === 'fullscreen') {
            html = <div className="compareBtn"
                        onClick={this.cleanCompare.bind(this)}>{this.state.general.labelCompareOthers}</div>
        }
        return html;
    }

    startCompare() {
        let h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        document.body.className += 'hide-scroll';
        this.setState({
            compareStatus: "fullscreen",
            labelPhoneComparison: this.state.general.labelCompare,
            compareStyle: {
                "height": h + "px"
            }
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSpecs: true
                })
            }, 400)
        });
    }

    getFilterBrandsList() {
        let html = this.state.brands.map((brand, brandIndex) => {

            var filter = this.state.tempFilter || this.state.filter;
            var selected = false;
            if (filter && filter.brands && filter.brands.indexOf(brand.id) !== -1) {
                selected = true;
            }
            return <li className={selected ? 'selected ' : ' '} key={'brand_' + brandIndex}
                       onClick={this.toggleBrandToFilter.bind(this, brand.id)}>{brand.label}</li>

        })
        return html;
    }

    getFilterGenerationsList = () => {
        let html = this.state.networkGenerations.map((generation, brandIndex) => {

            var filter = this.state.tempFilter || this.state.filter;
            var selected = false;
            if (filter && filter.networkGenerations && filter.networkGenerations.indexOf(generation.id) !== -1) {
                selected = true;
            }
            return <li className={selected ? 'selected ' : ' '} key={'generation_' + brandIndex}
                       onClick={() => this.toggleGenerationsToFilter(generation.id)}>{generation.label}</li>

        })
        return html;
    }

    toggleBrandToFilter(brandId) {
        var filter = this.state.tempFilter || this.state.filter;

        var index = filter.brands.indexOf(brandId);
        if (index !== -1) {
            filter.brands.splice(index, 1);
        } else {
            filter.brands.push(brandId)
        }

        this.setState({
            tempFilter: filter
        });
    }

    toggleGenerationsToFilter = (generationID) => {
        var filter = this.state.tempFilter || this.state.filter;

        var index = filter.networkGenerations.indexOf(generationID);
        if (index !== -1) {
            filter.networkGenerations.splice(index, 1);
        } else {
            filter.networkGenerations.push(generationID)
        }

        this.setState({
            tempFilter: filter
        });
    }

    showFilter() {
        var tempFilter = this.state.filter ?
            JSON.parse(JSON.stringify(this.state.filter)) : {
                brands: [],
                networkGenerations: [],
                priceRange: [0, 10000]
            };
        this.setState({
            showFilter: true,
            tempFilter: tempFilter
        });
    }

    cleanFilter() {
        this.setState({
            tempFilter: {
                brands: [],
                networkGenerations: [],
                priceRange: [0, 10000]
            }
        });
    }

    closeFilter() {
        this.setState({
            showFilter: false
        });
    }

    changeFilterRange(range) {
        let tempFilter = JSON.parse(JSON.stringify(this.state.tempFilter));
        tempFilter.priceRange = range;
        this.setState({
            tempFilter: tempFilter
        });
    }

    applyFilter() {
        let tempFilter = JSON.parse(JSON.stringify(this.state.tempFilter));
        tempFilter.label = "Filter";
        tempFilter.hidden = true;

        let filters = this.state.filters;
        filters = filters.filter(f => f.label !== "Filter");

        filters.push(tempFilter);

        this.setState({
            filter: tempFilter,
            filters: filters,
            showedMobile: 4,
            expandPage: 1,
            showFilter: false
        }, () => {
            this.switchFilter(filters[filters.length - 1], true);
        });
    }


    switchFilter(filter, isHideTag) {

        this.setState({
            selectFilter: filter.label,
            isHideTag: isHideTag || false
        }, () => {

            let target = this.selectedBrandDom;

            let left = target.getBoundingClientRect().left - target.parentNode.getBoundingClientRect().left;
            let width = target.getBoundingClientRect().width;

            let filterPhones = [];

            filterPhones = this.state.phones.filter(phone => {
                let isInBrand = true;
                let isInPrice = true;
                let isInGenerations = true;

                if (filter.brands && filter.brands.length) {
                    if (filter.brands.indexOf(phone.brandId) !== -1) {
                        isInBrand = true;
                    } else {
                        isInBrand = false;
                    }
                } else {
                    isInBrand = true;
                }

                console.log(filter.networkGenerations)

                if (filter.networkGenerations && filter.networkGenerations.length) {
                    if (filter.networkGenerations.indexOf(phone.networkGeneration) !== -1) {
                        isInGenerations = true;
                    } else {
                        isInGenerations = false;
                    }
                } else {
                    isInGenerations = true;
                }

                if (filter.priceRange && filter.priceRange.length) {
                    isInPrice = false;
                    let maxPriceVaule = filter.priceRange[1] === 10000 ? Infinity : filter.priceRange[1];

                    phone.price.map((p, pIndex) => {
                        if (p.price >= filter.priceRange[0] && p.price <= maxPriceVaule) {
                            isInPrice = true;
                        }
                        return null;
                    })
                }

                return (isInBrand && isInPrice && isInGenerations)
            })

            let showExpand = filterPhones.length > 10 ? true : false;
            let showMobileExpand = filterPhones.length > 4 ? true : false;

            this.setState({
                switching: true,
                brandLeft: left,
                brandWidth: width,
                opening: false,
                containerStyle: {},
                expandPage: 1
            }, () => {
                setTimeout(() => {
                    this.setState({
                        switching: false,
                        filterPhones: filterPhones,
                        showExpand: showExpand,
                        showMobileExpand: showMobileExpand
                    });
                }, 400);
            });
        });
    }

    getTop(ele) {
        let curtop = 0;
        if (ele.offsetParent) {
            do {
                curtop += ele.offsetTop;
            } while (ele = ele.offsetParent);
            return curtop - 60;
        }
    }

    backtotop() {
        let top = this.getTop(this.PhoneCompare);
        window.scroll(0, top);
    }

    render() {
        return (
            <div className="phone-compare container" ref={(PhoneCompare) => {this.PhoneCompare = PhoneCompare;}}>
                <div className="">
                    <div className="phone-compare-title">
                        <h3>{this.state.general.title}</h3>
                        <p>{this.state.general.text}</p>
                    </div>

                    <div className="phone-compare-brands clearfix">
                        <div className={this.state.isHideTag ? "brandsBg hidden-xs hiding" : "brandsBg hidden-xs"}
                             ref="brandsBg" style={{
                            transform: 'translate(' + this.state.brandLeft + 'px , 0)',
                            'msTransform': 'translate(' + this.state.brandLeft + 'px , 0)',
                            width: this.state.brandWidth + 'px'
                        }}>
                        </div>

                        <ul className="col-md-10 col-sm-10 hidden-xs">
                            {this.getFiltersList()}
                        </ul>

                        <div className="col-md-2 col-sm-2 col-xs-12 filterWrap">
                            <div className="moreFilter hidden-xs"
                                 onClick={this.showFilter.bind(this)}>{this.state.general.labelMoreFilter || "Filter More"}</div>
                            <div className="moreFilter visible-xs-inline-block"
                                 onClick={this.showFilter.bind(this)}>{this.state.general.labelFilter}</div>
                        </div>
                    </div>

                    <div className="phone-compare-phones clearfix">
                        <div
                            className={"compare-container " + (this.state.switching ? 'hiding ' : 'showing ') + (this.state.opening ? 'opening ' : '')}
                            ref={(container) => {this.compareContainer = container}} style={this.state.containerStyle}>

                            {this.state.filterPhones.length ?
                                <ul>
                                {this.getPhonesList()}
                                {[0, 1, 2, 3, 4].map((value, index) => {
                                    return [<li key={'_p_' + index}
                                                style={{visibility: 'hidden', 'height': '0', 'margin': '0'}}></li>, ' ']
                                })}
                                </ul>
                                :
                                <div className="phoneEmptyWrap">
                                    <p>{this.state.general.labelEmptyPhones || 'Sorry,we can not find what you are looking for.'}</p>
                                </div>
                            }
                        </div>

                        <div className={"expandWrap hidden-xs " + (this.state.showExpand ? 'showing' : 'hiding')} onClick={this.showMoreResult.bind(this)}>
                            <p>{this.state.general.labelExpandToViewMore}</p>
                            <img alt="" className="icon_more" src={IconMore}/>
                        </div>

                        <div className="expandMobileWrap visible-xs-block">
                            <div className="expandMobileBtns">
                                <div className="expandMobileBtn" onClick={this.backtotop.bind(this)}>
                                    <img alt="" className="icon_top" src={IconTop}/>
                                    <span>{this.state.general.labelBackToTop}</span>
                                </div>
                                &nbsp;
                                <div className={"expandMobileBtn " + (this.state.showMobileExpand ? 'showing' : 'hiding')}
                                    onClick={this.showMoreMobileResult.bind(this)}>
                                    <span>{this.state.general.labelViewMore}</span>
                                    <img alt="" className="icon_more" src={IconMore}/>
                                </div>
                            </div>

                            {this.state.filterPhones.length ?
                                <div className="pageInfo">
                                    {Math.min(this.state.showedMobile, this.state.filterPhones.length)} of {this.state.filterPhones.length} Phones</div>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>

                <div className={"phone-compare-toolbar " + this.state.compareStatus} style={this.state.compareStyle}>
                    <div className="container">
                        <div className="title">
                            <div className="cleanBtn hidden-xs" onClick={this.cleanCompare.bind(this)}>{this.state.general.labelClearAll}</div>
                            <div>{this.state.labelPhoneComparison}</div>
                            <div className="switchBtn" onClick={this.switchCompare.bind(this)}>
                                <img src={IconMore} alt=""/>
                            </div>
                        </div>

                        <div className="compareContent">
                            <ul>
                                {this.getCamparePhonesList()}
                            </ul>
                            <div className={this.state.showSpecs ? "vs showing" : "vs"}>{this.state.general.labelVS}</div>
                        </div>

                        <div className="compareBtns">
                            {this.getCampareBtns()}
                        </div>
                    </div>
                </div>

                {this.state.showFilter ?
                    <div className="phone-compare-filter">
                        <div className="container">
                            <div className="title">
                                <div className="cleanBtn hidden-xs"
                                     onClick={this.cleanFilter.bind(this)}>{this.state.general.labelClearAll}</div>
                                <div>{this.state.general.labelFilter}</div>
                                <div className="closeBtn" onClick={this.closeFilter.bind(this)}>
                                    <img src={IconClose2} alt=""/>
                                </div>
                            </div>
                            <div className="filter-brands">
                                <div className="name text-uppercase">{this.state.general.labelBrand}</div>
                                <ul>
                                    {this.getFilterBrandsList()}
                                </ul>
                            </div>
                            <div className="filter-generations">
                                <div className="name text-uppercase">{this.state.general.labelNetworkGenerations}</div>
                                <ul>
                                    {this.getFilterGenerationsList()}
                                </ul>
                            </div>
                            <div className="filter-btns">
                                <div className="filter-btns-wrap">
                                    <div className="cleanBtn2 visible-xs-inline-block text-uppercase"
                                         onClick={this.cleanFilter.bind(this)}>{this.state.general.labelClearAll}</div>
                                    <div className="applyBtn text-uppercase"
                                         onClick={this.applyFilter.bind(this)}>{this.state.general.labelApply}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}

export default PhoneCompare;